import { render, staticRenderFns } from "./XTreeMenu.vue?vue&type=template&id=5194309c&"
import script from "./XTreeMenu.ts?vue&type=script&lang=ts&"
export * from "./XTreeMenu.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "XTreeMenu.vue"
export default component.exports